import { useCallback } from "react";
import { useHistory } from "react-router-dom";

import type { useNavigationReturn, NavigateFn } from "@smartrent/shared-ui";

/**
 * @private This should only be used internally inside of SmartKit. For user facing applications please use "useHistory" directly from "react-router-dom"
 */
export function useNavigation(): useNavigationReturn {
  const history = useHistory();

  const navigate = useCallback<NavigateFn>(
    (to) => {
      history.push(to);
    },
    [history]
  );

  return {
    navigate,
    goBack: history.goBack,
  };
}
